import { http } from './client';
export type ClientDepositPolicy = { waiveAtOrBelow10000: boolean; revision: number };
async function request(companyId: string, data?: ClientDepositPolicy) {
  const { response, error } = await http<{ data: ClientDepositPolicy }>({ method: data ? 'PUT' : 'GET', url: `companies/${encodeURIComponent(companyId)}/deposit-policy`, isToken: true,
    ...(data ? { data: { waiveAtOrBelow10000: data.waiveAtOrBelow10000, expectedRevision: data.revision } } : {}) });
  if (error || !response) throw new Error(error?.response?.data?.message || 'Could not load or save the company deposit policy.');
  const result = response.data?.data;
  if (!result || typeof result.waiveAtOrBelow10000 !== 'boolean' || !Number.isSafeInteger(result.revision)) throw new Error('Invalid deposit policy response.');
  return result;
}
export const clientDepositPolicy = { get: (id: string) => request(id), save: (id: string, data: ClientDepositPolicy) => request(id, data) };
